import type { ReactNode } from "react"

export const APP_CONFIG = {
  MOBILE_SIZE: 640,
} as const

type MenuItem = {
  title: string
  path: string
  subtitle?: string
  icon: ReactNode
  iconSelected: ReactNode
  hoverColor: string
}

const profileImage =
  typeof window !== "undefined"
    ? localStorage.getItem("profilePic")
    : null

const profileAvatar = (
  <img
    src={profileImage || ""}
    alt="Profile"
    className="size-6 rounded-full object-cover"
  />
)

export const MENU: MenuItem[] = [
  {
    title: "Inicio",
    path: "/",
    icon: <i className="f7-icons">app</i>,
    iconSelected: <i className="f7-icons">app_fill</i>,
    hoverColor: "rgba(0, 0, 255, .8)", /* rgba(56, 98, 181, 0.3) */
  },
  {
    title: "Colección",
    path: "/library",
    icon: <i className="f7-icons">rectangle_grid_3x2</i>,
    iconSelected: (
      <i className="f7-icons">rectangle_grid_3x2_fill</i>
    ),
    hoverColor: "rgba(0, 255, 136, .8)", /* rgba(144, 224, 239, .3) */
  },
  {
    title: "Radio",
    subtitle: "Radio",
    path: "/radio",
    icon: <i className="f7-icons">waveform</i>,
    iconSelected: <i className="f7-icons">waveform_fill</i>,
    hoverColor: "rgba(255, 0, 38, .8)", /* rgba(75, 75, 204, .4) */
  },
  {
    title: "Métricas",
    path: "/insights",
    icon: <i className="f7-icons">status</i>,
    iconSelected: <i className="f7-icons">status_fill</i>,
    hoverColor: "rgba(255, 255, 1, .8)",
  },
  /* {
    title: "Noticias",
    path: "/news",
    icon: <i className="f7-icons">status</i>,
    iconSelected: <i className="f7-icons">status_fill</i>,
    hoverColor: "rgba(255, 255, 1, 0.5)",
  }, */
  {
    title: "Configuración",
    path: "/ajustes",
    icon: profileImage ? (
      profileAvatar
    ) : (
      <i className="f7-icons">person</i>
    ),
    iconSelected: profileImage ? (
      profileAvatar
    ) : (
      <i className="f7-icons">person</i>
    ),
    hoverColor: "rgba(255, 255, 255, .8)", /* rgba(255, 255, 255, .2) */
  },
]

export const PLAYLISTBTN = [
  {
    title: "Favoritos",
    path: "/library/artists",
    ImgName: "popularSong",
  },
]

export const LIBRARYTABS = [
  {
    title: "Listas de reproducción",
    path: "/library",
  },
  {
    title: "Djs",
    path: "/library/artists",
  },
  {
    title: "Álbumes",
    path: "/library/albums",
  },
  {
    title: "Podcast",
    path: "/library/podcasts",
  },
]